import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';
import React from 'react';

interface Props {
    side: React.ReactNode;
    top: React.ReactNode;
    bottom: React.ReactNode;
    variations?: string[];
}

function ContentSideFeature({ side, top, bottom, variations }: Props) {
    const classNames = getComponentClasses('content-side-feature', variations ? variations : []);

    return (
        <div className={classNames}>
            <div className="content-side-feature__side">{side}</div>

            <div className="content-side-feature__top">{top}</div>

            <div className="content-side-feature__bottom">{bottom}</div>
        </div>
    );
}

export default ContentSideFeature;
